import * as React from "react";
import Register from "../src/components/layouts/Register";
import Account from "../src/components/Account/Account";
import "../src/index.css";
import Categories from "./components/Categories/Categories";
import ResourceTypes from "./components/ResourceTypes/ResourceTypes";
import Resources from "./components/Resources/Resources";
import Dashboard from "./components/Dashboard/dashboard";
import Products from "./components/Product/product";
import Users from "./components/user/users";
import Jobs from "./components/job/jobs";
import Reports from "./components/reports/Reports";
import Organizations from "./components/Organizations/Organizations";
import RoadmapTemplates from "./components/RoadmapTemplates/RoadmapTemplates";

export const routes = [
  {
    name: "Dashboard",
    element: <Dashboard />,
    path: "/dashboard",
  },
  {
    name: "Products",
    element: <Products />,
    path: "/projects",
  },
  {
    name: "Organizations",
    element: <Organizations />,
    path: "/organizations",
  },
  {
    name: "Categories",
    element: <Categories />,
    path: "/categories",
  },
  {
    name: "ResourceTypes",
    element: <ResourceTypes />,
    path: "/resource-types",
  },
  {
    name: "Resources",
    element: <Resources />,
    path: "/resources",
  },
  {
    name: "Register",
    element: <Register />,
    path: "/register",
  },
  {
    name: "Account",
    element: <Account />,
    path: "/account",
  },
  {
    name: "Users",
    element: <Users />,
    path: "/users",
  },
  {
    name: "Jobs",
    element: <Jobs />,
    path: "/jobs",
  },
  {
    name: "Reports",
    element: <Reports />,
    path: "/reports",
  },
  {
    name: "RoadmapTemplates",
    element: <RoadmapTemplates />,
    path: "/roadmap-templates",
  },
];
